import { isNil, pathOr } from '../utils/fp';

const parseNumber = value => (!isNil(value) ? Number(value) : value);

// the condition should only be urlv3 in an ideal world
// any space with the attributes urlv3 is supposed to support sdmx v3
// the problem is that today the NSI doesn't support metadata and rely on sdmx v3 extension to support it
// consequence is that the NSI has urlv2 and urlv3 only for metadata
// isSC is added (and later isFMR) to overcome this issue
// it's possible to update tenants.json but the NSI is planned to be removed, so waiting is only a possibility
// that may dodge support
export const getIsV3 = datasource => datasource?.urlv3 && datasource?.isSC;

export const getRangeHeaderValue = value => {
  let arr = Array.isArray(value) ? value : [value];
  if (arr.length === 1) arr = ['0', arr[0] - 1];
  return `values=${arr[0]}-${arr.at(-1)}`;
};

export const parseDataRange = response => {
  const str = pathOr('', ['headers', 'content-range'], response);
  const matched = str.match(/values (\d+)-(\d+)\/(\d+)/);
  const [start, end, total] = (isNil(matched) ? [] : matched).slice(1, 4).map(parseNumber);
  if ([start, end, total].some(value => isNil(value) || isNaN(value))) {
    return {};
  }
  const count = end - start + 1;
  return { count, total };
};
